module.exports = __webpack_public_path__ + "static/media/Altaria_gaussian2.f2a1af5b.png";